import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=49cd8e9e"
import script from "./CandidateCard.vue?vue&type=script&lang=js"
export * from "./CandidateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports